export function separateName(fullName: string): {
	firstName: string;
	middleInit: string;
	lastName: string;
} {
	// Format: "LAST, FIRST MIDDLE"
	const [lastRaw, rest] = fullName.split(", ");
	if (!rest) return { lastName: lastRaw ?? "", firstName: "", middleInit: "" };
	const [firstName, middleInit] = rest.split(" ");
	return {
		lastName: lastRaw ?? "",
		firstName: firstName ?? "",
		middleInit: middleInit ?? "",
	};
}

export function toTitleCase(s: string): string {
	return s.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

export function fmtDate(s: string): string {
	return new Date(s).toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		year: "numeric",
	});
}
